/* Sully & Co. product page helpers. Loaded on product templates only. */
(function () {
  // Move the Kiwi "Size Chart" link onto the Size label row. The app keeps its own click handling.
  function placeSizeChart() {
    var legend = document.querySelector('.product__content .radio__legend--size');
    var chart = document.querySelector('.product__content .ks-chart-container');
    if (!legend || !chart) return false;
    if (legend.contains(chart)) return true;
    var oldBlock = chart.closest('.shopify-block');
    legend.appendChild(chart);
    if (oldBlock && !oldBlock.textContent.trim()) oldBlock.classList.add('sully-moved-empty');
    return true;
  }

  // Add a small product photo to the sticky add-to-cart bar.
  function addCartBarThumb() {
    var bar = document.querySelector('cart-bar .cart-bar__form__wrapper');
    if (!bar || bar.querySelector('.sully-cart-bar__thumb')) return;
    var img = document.querySelector('.product__images .product__photo img, .product__images img');
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    var thumb = document.createElement('img');
    thumb.className = 'sully-cart-bar__thumb';
    thumb.src = src;
    thumb.alt = '';
    thumb.width = 44;
    thumb.height = 52;
    thumb.loading = 'lazy';
    bar.insertBefore(thumb, bar.firstChild);
  }

  // Keep the slim sticky bar visible whenever the main Add to cart button is off screen,
  // including before the shopper has scrolled down to it.
  function watchMainButton() {
    var bar = document.querySelector('cart-bar');
    var main = null;
    document.querySelectorAll('.product__content button[name="add"], .product__content .product__submit__buttons button').forEach(function (b) {
      if (!main && !b.closest('cart-bar')) main = b;
    });
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('sully-cart-bar--show', !entry.isIntersecting);
      });
    }).observe(main);
  }

  function init() {
    addCartBarThumb();
    watchMainButton();
    if (placeSizeChart()) return;
    // Kiwi renders after page load, so watch for it for a few seconds.
    var observer = new MutationObserver(function () {
      if (placeSizeChart()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
